import { get } from 'lodash'
export default class Preview {
	/** @constructor
	 * @param {Object} init
	 * @property {string} jpeg
	 * @property {string} jpg
	 * @property {string} pdf
	 * @property {string} png
	 * @property {string} webp
	 */
	constructor (init = {}) {
		this.jpeg = get(init, 'jpeg') ? init.jpeg : null
		this.jpg = get(init, 'jpg') ? init.jpg : null
		this.pdf = get(init, 'pdf') ? init.pdf : null
		this.png = get(init, 'png') ? init.png : null
		this.webp = get(init, 'webp') ? init.webp : null
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/Preview.js